import React, { useContext } from "react";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import Avatar from "@mui/joy/Avatar";
import Sheet from "@mui/joy/Sheet";
import Chip from "@mui/joy/Chip";
import Button from "@mui/joy/Button";
import AvatarGroup from "@mui/joy/AvatarGroup";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import AutoAwesomeMotionIcon from "@mui/icons-material/AutoAwesomeMotion";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import { ChatContext } from "../mensajecontext";
import ModalParticipante from "../../../aventuras/modalparticipantes";
import { Modal } from "@mui/base";

export default function HeaderchatGrupal({ datoschat, datosaventura }) {
  const { aparecerDisenoChat } = useContext(ChatContext);
  let almacenamientoURL = process.env.REACT_APP_DOSPACES;
  let [estadoModal, setEstadoModal] = React.useState(false);

  let headerMobile = () => {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
        }}
      >
        <Box
          sx={{
            display: "grid",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
            textAlign: "center",
            gap: 1,
            margin: 5,
            marginTop: 3,
          }}
        >
          <Button
            onClick={aparecerDisenoChat}
            startDecorator={<KeyboardReturnIcon />}
            variant="plain"
            color="neutral"
            size="sm"
          >
            Volver
          </Button>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <Button
              variant="plain"
              color="neutral"
              onClick={() => {
                setEstadoModal(true);
              }}
            >
              <AvatarGroup>
                {datoschat.participantes.slice(0, 4).map((x, index) => {
                  return (
                    <Avatar
                      size="lg"
                      src={`${almacenamientoURL}/uploads/${x.foto_de_perfil}`}
                      key={index}
                    />
                  );
                })}
                {datoschat.participantes.length > 4 && (
                  <Avatar size="lg">
                    +{datoschat.participantes.length - 4}
                  </Avatar>
                )}
              </AvatarGroup>
            </Button>
          </Box>

          <Typography level="title-lg">
            {datosaventura ? `${datosaventura.titulo}` : null}
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 1,
              alignItems: "center",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            {" "}
            <Chip size="sm" startDecorator={<PriorityHighIcon fontSize="" />}>
              {datosaventura.nombre_nivel}
            </Chip>
            <Chip
              size="sm"
              startDecorator={<AutoAwesomeMotionIcon fontSize="" />}
            >
              {datosaventura.nombre_categoria}
            </Chip>
          </Box>
          <Button
            variant="outlined"
            color="neutral"
            onClick={() => {
              window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/share/aventura/${datosaventura.id_actividad}`;
            }}
            sx={{ marginTop: 1 }}
          >
            Ver Aventura
          </Button>
        </Box>
      </Box>
    );
  };

  let headerDesktop = () => {
    return (
      <Box>
        <Box sx={{ display: "flex", margin: 5, gap: 2 }}>
          <Box>
            <Button
              variant="plain"
              color="neutral"
              onClick={() => {
                setEstadoModal(true);
              }}
            >
              <AvatarGroup>
                {datoschat.participantes.slice(0, 4).map((x, index) => {
                  return (
                    <Avatar
                      size="lg"
                      src={`${almacenamientoURL}/uploads/${x.foto_de_perfil}`}
                      key={index}
                    />
                  );
                })}
                {datoschat.participantes.length > 4 && (
                  <Avatar size="lg">
                    +{datoschat.participantes.length - 4}
                  </Avatar>
                )}
              </AvatarGroup>
            </Button>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: 0,
              alignContent: "center",
              alignItems: "center",
              justifyContent: "center",
              flexGrow: 1,
            }}
          >
            <Box sx={{ display: "flex-grid" }}>
              <Typography level="title-lg">
                {datosaventura ? `${datosaventura.titulo}` : null}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  alignContent: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 0.5,
                  marginTop: 1,
                }}
              >
                <Chip
                  size="sm"
                  startDecorator={<PriorityHighIcon fontSize="" />}
                >
                  {datosaventura.nombre_nivel}
                </Chip>
                <Chip
                  size="sm"
                  startDecorator={<AutoAwesomeMotionIcon fontSize="" />}
                >
                  {datosaventura.nombre_categoria}
                </Chip>
              </Box>
            </Box>
          </Box>
          <Box sx={{ marginLeft: "auto" }}>
            <Button
              variant="outlined"
              color="neutral"
              onClick={() => {
                window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/share/aventura/${datosaventura.id_actividad}`;
              }}
            >
              Ver Aventura
            </Button>
          </Box>
        </Box>
      </Box>
    );
  };

  return (
    <Box>
      <Box
        sx={{
          display: { xs: "grid", md: "none", lg: "none" },
        }}
      >
        {headerMobile()}
      </Box>
      <ModalParticipante
        estado={estadoModal}
        participantes={datoschat.participantes}
        cerrar={() => setEstadoModal(false)}
      />
      <Box sx={{ display: { xs: "none", md: "grid", lg: "grid" } }}>
        {headerDesktop()}
      </Box>
    </Box>
  );
}
